import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UnstyledDropdownToggle from 'components/bootstrap_extensions/bs5/unstyled_dropdown_toggle';
import {
  faEdit,
  faEllipsisVertical,
  faFileExport,
  faLock,
  faMailbox,
  faTrash
} from '@fortawesome/pro-solid-svg-icons';
import CallListExportModal from '../call_lists/export/modal';
import ExportUnavailable from '../call_lists/export/export_unavailable';
import type { DataExportTemplate } from 'bundles/connect/types';
import CallListDeleteModal from './call_list_delete_modal';
import { getRestrictedPropertiesForCallList, mailersTemplatesUrl } from 'bundles/connect/helpers/prospect_api';
import { Tooltip } from '@buildoutinc/blueprint-react/ui/Tooltip';

type Props = {
  callListId: number;
  callListName: string;
  exportDisabled?: string;
  pathForCallList: string;
  templates: DataExportTemplate[];
}


export default function CallListActionDropdown({
  callListId,
  callListName,
  exportDisabled,
  pathForCallList,
  templates
}: Props) {

  const [showExportModal, setShowExportModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [mailersDisabled, setMailersDisabled] = useState(false);
  const [allRestrictedChecked, setAllRestrictedChecked] = useState(false);

  const checkRestrictedProperties = async (nextShow: boolean) => {
    if (!nextShow || allRestrictedChecked) return;

    try {
      const { allRestricted } = await getRestrictedPropertiesForCallList(callListId);
      setMailersDisabled(allRestricted);
    } finally {
      setAllRestrictedChecked(true);
    }
  };

  const mailersButton = () => {
    return mailersDisabled ? (
      <Tooltip.Provider>
        <Tooltip>
          <Tooltip.Trigger render={<div />}>
            <Dropdown.Item data-turbo={false} disabled href={mailersTemplatesUrl(callListId)}>
              <FontAwesomeIcon className="me-2" fixedWidth icon={faMailbox} />
              Create Mailers
            </Dropdown.Item>
          </Tooltip.Trigger>
          <Tooltip.Content>All properties in this list are out of your selected counties</Tooltip.Content>
        </Tooltip>
      </Tooltip.Provider>
    ) :
      (
        <Dropdown.Item data-turbo={false} disabled={mailersDisabled} href={mailersTemplatesUrl(callListId)}>
          <FontAwesomeIcon className="me-2" fixedWidth icon={faMailbox} />
          Create Mailers
        </Dropdown.Item>
      );
  };

  return (
    <>
      <Dropdown onToggle={checkRestrictedProperties}>
        <Dropdown.Toggle as={UnstyledDropdownToggle}>
          <span className="d-flex align-items-center justify-content-center p-2 clickable">
            <FontAwesomeIcon icon={faEllipsisVertical} />
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu className="py-0" renderOnMount>
          {exportDisabled ? (
            <ExportUnavailable disabled={exportDisabled}>
              <div>
                <Dropdown.Item disabled>
                  <FontAwesomeIcon className="me-2" fixedWidth icon={faLock} />
                  Export List
                </Dropdown.Item>
              </div>
            </ExportUnavailable>
          ) :
            (
              <Dropdown.Item onClick={() => setShowExportModal(true)}>
                <FontAwesomeIcon className="me-2" fixedWidth icon={faFileExport} />
                Export List
              </Dropdown.Item>
            )}
          <Dropdown.Item data-turbo={false} href={pathForCallList}>
            <FontAwesomeIcon className="me-2" fixedWidth icon={faEdit} />
            Edit List
          </Dropdown.Item>
          {mailersButton()}
          <Dropdown.Item className="text-danger" onClick={() => setShowDeleteModal(true)}>
            <FontAwesomeIcon className="me-2" fixedWidth icon={faTrash} />
            Delete List
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <CallListExportModal
        callListId={callListId}
        show={showExportModal}
        templates={templates}
        onHide={() => setShowExportModal(false)}
      />
      <CallListDeleteModal
        callListName={callListName}
        pathForCallList={pathForCallList}
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
      />
    </>
  );
}
